import React from 'react'
import PropTypes from 'prop-types'
import {Blocks} from '@builder.io/sdk-react'
import {Carousel} from '@/components/ui/carousel'
import {
    defaultPreviousButton,
    defaultNextButton,
    deprecatedDefaultCarouselContent,
    defaultContentNav
} from '../../carousel/defaultConfig'
import {cn} from '@/lib/utils'

export const DeprecatedCustomCarousel = (props) => {
    const {children, loop, slidesToScroll, align, attributes, content, builderBlock} = props
    const {className, ...restAttributes} = attributes
    return (
        <Carousel
            opts={{loop, slidesToScroll, align}}
            className={cn('mx-auto w-[80%]', className)}
            {...restAttributes}
            data-testid="carousel-Carousel"
        >
            {/* {children} */}
            <Blocks
                path="component.options.content"
                blocks={content}
                parent={builderBlock?.id}
                data-testid={'carousel-Blocks'}
            />
        </Carousel>
    )
}

DeprecatedCustomCarousel.propTypes = {
    attributes: PropTypes.object,
    align: PropTypes.string,
    carouselButtonIcon: PropTypes.string,
    contentWidth: PropTypes.number,
    loop: PropTypes.bool,
    slidesToScroll: PropTypes.number,
    children: PropTypes.node,
    builderBlock: PropTypes.object,
    content: PropTypes.arrayOf(PropTypes.object.isRequired)
}

export const DeprecatedCarouselDefinition = {
    component: DeprecatedCustomCarousel,
    name: 'Carousel',
    hideFromInsertMenu: true,
    canHaveChildren: true,
    childRequirements: {
        message:
            "Children of 'Carousel' must be 'CarouselButton', 'CarouselContentNav', or 'CarouselContent'",
        query: {
            'component.name': {
                $in: ['CarouselButton', 'CarouselContent', 'CarouselContentNav']
            }
        }
    },
    noWrap: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    defaultStyles: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '10px',
        marginBottom: '10px',
        width: '80%'
    },
    defaultChildren: [
        defaultPreviousButton,
        deprecatedDefaultCarouselContent,
        defaultNextButton,
        defaultContentNav
    ],
    inputs: [
        {
            name: 'align',
            type: 'string',
            enum: ['start', 'center', 'end'],
            defaultValue: 'start',
            helperText: 'Align the slides relative to the carousel viewport.'
        },
        {
            name: 'loop',
            type: 'boolean',
            defaultValue: true,
            helperText: 'Enables infinite looping.'
        },
        {
            name: 'slidesToScroll',
            type: 'number',
            defaultValue: 1,
            helperText: 'Group slides together.'
        }
    ]
}
